import { 
  addDoc, 
  collection, 
  collectionGroup, 
  deleteDoc, 
  doc, 
  getDoc, 
  getDocs 
} 
  from 'firebase/firestore';
import { db, storage } from './firebaseConfig';
import { ref, getDownloadURL, uploadBytes } from 'firebase/storage'; 
import { i18n } from '@/i18n';

const componentData = {
  getComponents: async () => {
    const lang = i18n.locale || 'es';
    
    if (lang === 'es') {
      const snapshot = await getDocs(collection(db, 'components'));
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } else {
      const snapshot = await getDocs(collectionGroup(db, 'languages'));

      const translatedComponents = [];

      snapshot.forEach(docSnap => {
        if (docSnap.id === lang) {
          const parentPath = docSnap.ref.parent.parent.path;
          
          // Solo aceptar si el padre está en 'components'
          if (parentPath.startsWith('components/')) {
            const translation = docSnap.data();
            const componentId = docSnap.ref.parent.parent.id;

            translatedComponents.push({
              id: componentId,
              ...translation
            });
          }
        }
      });
      return translatedComponents;
    }
  },

  addComponent: async (component) => {
    const docRef = await addDoc(collection(db, 'components'), component);
    const docSnap = await getDoc(docRef);
    return { id: docSnap.id, ...docSnap.data() };
  },
  async updateComponent(componentId, updatedComponent) {
    await db.collection('components').doc(componentId).update(updatedComponent);
  },

  async deleteComponent(id, imageUrl) {
    const docRef = doc(db, 'components', id);
    await deleteDoc(docRef);

    if (imageUrl) {
      const imageRef = ref(storage, imageUrl);
      await deleteObject(imageRef);
    }
  },

  async uploadImage(file) {
    const storageRef = ref(storage, `images/${file.name}`)
    await uploadBytes(storageRef, file)
    const url = await getDownloadURL(storageRef)
    return url
  }
};

export default componentData;
